import { DropdownWidth, Option } from '@by-miles/bymiles-styles/dist/molecules/Dropdown'
import { DataLayer } from '@by-miles/data-layer'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import React, { useContext, useState } from 'react'

import { updateQuoteMutation } from '../hooks/updateQuote'
import { ProviderContext } from '../Provider'
import { daysWithinNextMonth } from '../utils/daysWithinNextMonth'
import { EditableDropdownPanel } from './shared/EditableDropdownPanel'

dayjs.extend(utc)

interface InceptionDateDropdownProps {
  inceptionDate: string
  onInfoClick: () => void
}

export const InceptionDateDropdown = ({ inceptionDate, onInfoClick }: InceptionDateDropdownProps) => {
  const {
    state: { quoteId },
  } = useContext(ProviderContext)
  const { updateQuote } = updateQuoteMutation()
  const [inceptionDateValue, setInceptionDate] = useState(inceptionDate)

  const preFilledValue = dayjs().isSame(dayjs(inceptionDateValue), 'day')
    ? `${dayjs(inceptionDateValue).format('MMM D, YYYY')} (now)`
    : dayjs(inceptionDateValue).format('MMM D, YYYY')

  return (
    <EditableDropdownPanel
      primaryTitle="policy starts"
      secondaryTitle="policy ends"
      secondaryInfo={`23:59 ON ${dayjs(preFilledValue)
        .add(1, 'years')
        .subtract(1, 'days')
        .format('DD MMM YYYY')
        .toUpperCase()}`}
      infoTitle="More info on start dates"
      options={daysWithinNextMonth()}
      preFilledValue={preFilledValue}
      width={DropdownWidth.Medium}
      handleDropdownChange={(option: Option) => {
        setInceptionDate(option.value)
        DataLayer.customEvent({
          eventName: 'submit',
          section: 'inception date',
          eventType: 'form submit',
        })
        updateQuote({
          variables: {
            id: quoteId as string,
            actions: [{ setInceptionDate: { inceptionDate: option.value } }],
          },
        })
      }}
      onInfoClick={onInfoClick}
      dataDogActionName="Edit Inception Date"
    />
  )
}
